import { ErrorMessage } from 'acscp/api/models/errorMessage';
import { defineMessages, FormattedMessage } from 'react-intl';
import log from 'loglevel';

export const ClientInsufficientAuthErrorKey = 'ClientInsufficientAuth';
export const ServiceTemporarilyUnavailableKey = 'ServiceTemporarilyUnavailable';

const messages: {[key: string]: FormattedMessage.MessageDescriptor} = defineMessages({

    PasswordLoginFailed: {
        id: 'serverError.passwordLoginFailed',
        defaultMessage:
            'We did not recognise the email address and password combination supplied. Please try again.\n' +
            'If you continue to have issues, please contact your account manager.'
    },
    MissingBroker: {
        id: 'serverError.missingBroker',
        defaultMessage: 'No broker has been assigned to this user account. Contact ACS to resolve this issue.',
    },
    GiftsNotAvailable: {
        id: 'serverError.GiftsNotAvailable',
        defaultMessage: 'Some of the items in your basket are no longer available.',
    },
    GiftsInWrongRegion: {
        id: 'serverError.GiftsInWrongRegion',
        defaultMessage: 'Some of the gifts in your basket are not available in your region.',
    },
    InsufficientPoints: {
        id: 'serverError.InsufficientPoints',
        defaultMessage: 'Unfortunately, you do not have enough loyalty points for all the items in your basket.',
    },
    CustomerPortalUserLinkInviteInvalidEmailAddress: {
        id: 'serverError.customerPortalUserLinkInviteInvalidEmailAddress',
        defaultMessage: 'Could not send invitation to link account. ' +
                        'Account has already been linked or an invite to that email already exists.',
    },
    CustomerPortalUserLinkInviteSendingFailed: {
        id: 'serverError.customerPortalUserLinkInviteSendingFailed',
        defaultMessage: 'Error sending invitation to link account.',
    },
    CannotLinkToSelf: {
        id: 'serverError.CannotLinkToSelf',
        defaultMessage: 'Your account cannot be linked to itself. ' +
            'Please sign out and try again using the account you wish to link.',
    },
    CannotLinkAgain: {
        id: 'serverError.CannotLinkAgain',
        defaultMessage: 'Your account is already linked to from that account. ' +
            'Please sign out and try again using the account you wish to link.',
    },
    CannotAcceptAccountLink: {
        id: 'serverError.CannotAcceptAccountLink',
        defaultMessage: 'We were not able to accept the request to link to your account. Contact ACS to resolve this issue.',
    },
    AccountLinkTokenExpired: {
        id: 'serverError.accountLinkTokenExpired',
        defaultMessage: 'We were not able to accept the request to link to your account. The token has expired.',
    },
    // Note that this message most likely won't be shown
    // The error is handled by showing special pages with specific explanations and update buttons
    AppUpdateRequired: {
        id: 'serverError.appUpdateRequired',
        defaultMessage: 'You must update JetPortal to continue. Please download the latest version.'
    },
    BookingInvalidForChangeRequest: {
        id: 'serverError.bookingInvalidForChangeRequest',
        defaultMessage: 'Booking is in a state disallowing change requests.'
    },
    QuoteInvalidForAccepting: {
        id: 'serverError.quoteInvalidForAccepting',
        defaultMessage: 'The selected quote could not be accepted.'
    },
    AnotherQuoteAlreadyAccepted: {
        id: 'serverError.anotherQuoteAlreadyAccepted',
        defaultMessage: 'Another quote has been already accepted.'
    },

    [ServiceTemporarilyUnavailableKey]: {
        id: 'serverError.serviceUnavailable',
        defaultMessage: 'JetPortal is temporarily unavailable. Please try again later.'
    },

    [ClientInsufficientAuthErrorKey]: {
        id: 'clientError.insufficientAuth',
        defaultMessage: 'You do not have access to that resource.',
    },
});

export function getTranslatableErrorMessage(message: ErrorMessage): string | FormattedMessage.MessageDescriptor {
    if (!message.code) {
        return message.text;
    }

    if (!messages[message.code]) {
        log.error('Received an error with unrecognised error code:', message.code);
        return message.text;
    }

    return messages[message.code];
}
